import * as quotesActionTypes from "../actions/qoutes";
import initialState from "./initialState";
export default (state = initialState.quotes, action) => {
  const { payload, type } = action;
  switch (type) {
    case quotesActionTypes.LIST_PAGE_QUOTES:
    case quotesActionTypes.LIST_PAGE_QUOTES_PENDING:
      return { ...state, quotes_loading: true };
    case quotesActionTypes.LIST_PAGE_QUOTES_REJECTED:
      return {
        ...state,
        error: true,
        errorMessage: payload.response.data,
        quotes_loading: false
      };
    case quotesActionTypes.LIST_PAGE_QUOTES_FULFILLED:
      return {
        ...state,
        error: false,
        quotes: payload.data,
        quotes_loading: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/quotes.js